module.exports = __webpack_public_path__ + "static/media/Loui.370455ef.png";